const AES_KEY_HEX = import.meta.env.VITE_AES_KEY;

const hexToBytes = (hex) =>
  new Uint8Array(hex.match(/.{1,2}/g).map((b) => parseInt(b, 16)));

// const base64ToBytes = (b64) =>
//   Uint8Array.from(atob(b64), c => c.charCodeAt(0));

const base64ToBytes = (b64) => {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
// const bytesToBase64 = (bytes) =>
//   btoa(String.fromCharCode(...bytes));
const bytesToBase64 = (bytes) => {
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};
async function getKey() {
  return crypto.subtle.importKey(
    "raw",
    hexToBytes(AES_KEY_HEX),
    "AES-GCM",
    false,
    ["encrypt", "decrypt"],
  );
}

export async function encryptPayload(data) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const key = await getKey();
  // console.log("IV length before encode:", iv.length);
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    new TextEncoder().encode(JSON.stringify(data)),
  );

  return {
    data: bytesToBase64(new Uint8Array(encrypted)),
    iv: bytesToBase64(iv),
  };
}

export async function decryptPayload(payload) {
  const key = await getKey();

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: base64ToBytes(payload.iv) },
    key,
    base64ToBytes(payload.data),
  );

  return JSON.parse(new TextDecoder().decode(decrypted));
}